/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AppControllerCreateTestPaymentPlan$Params {
  visitId: string;
}

export function appControllerCreateTestPaymentPlan(http: HttpClient, rootUrl: string, params: AppControllerCreateTestPaymentPlan$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, appControllerCreateTestPaymentPlan.PATH, 'post');
  if (params) {
    rb.path('visitId', params.visitId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

appControllerCreateTestPaymentPlan.PATH = '/keus-payments/test/create-payment-plan/{visitId}';
